import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { IStudentDocument } from '../../model/studentdocument';
import { ELookup } from '../../constants/eLookup';
import { ApiResult } from '@app/shared/model/apiresult';
import { ILookup } from '@app/shared/model/lookup';
import { emptyStudentDocument } from '../../constants/prepareEmptyObject';
import { LookupService } from '@app/modules/maintenance/services/lookup.service';
import { IStudent } from '../../model/student';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Guid } from 'guid-typescript';
import { StudentDocumentService } from '../../services/student-document.service';
import { Messages } from '../../constants/messages';
import { environment as env } from '@environments/environment'
import { ConfirmationDialog } from '../../component/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { IDocumentStore } from '../../model/documentstore';
import { InstitutionSearchDialog } from '@app/modules/shared/component/institution-search/institution-search.component';
import { ExportService } from '@app/shared/services/exportservice';

@Component({
    selector: 'app-studentdocument',
    templateUrl: 'studentdocument.component.html',
    styleUrls: ['studentdocument.component.css']

})

export class StudentDocumentComponent implements OnInit, AfterViewInit {
    @Input() WriteAction:boolean=false;
    institutionSearchDialogRef: any;
    documentTypes: ILookup[];
    documentSourceTypes: ILookup[];
    studentDocument: IStudentDocument = emptyStudentDocument();
    isShown: boolean = false;
    isEdit: boolean = false;
    isHighSchool: boolean;
    displayedColumns: string[] = ['documentType', 'description', 'requestDate', 'receiveDate', 'isOfficial'];
    dataSource = new MatTableDataSource<IStudentDocument>();
    documentDisplayedColumns: string[] = ['FileName', 'CreatedDate', 'Actions'];
    documentDataSource = new MatTableDataSource<IDocumentStore>();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) documentSort: MatSort;
    @ViewChild(MatPaginator, { static: true }) documentPaginator: MatPaginator;
    @ViewChild("fileDropRef", { static: true }) fileDropEl: ElementRef;
    disabled: boolean = false;
    uploadFiles: any[] = [];

    public studentDocumentFormGroup: UntypedFormGroup;
    studentID: Guid;
    selectedStudent: IStudent;
    public institutionList: ILookup[];

    constructor(private _snackBar: MatSnackBar,
        private _studentdocumentservice: StudentDocumentService,
        private _lookupservice: LookupService,
        private _formBuilder: UntypedFormBuilder,
        private dialog: MatDialog,
        private _route: ActivatedRoute,
        private _exportService:ExportService
        ) {
        this.fillForm(this.studentDocument);
    }

    ngOnInit() {
        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
        });
        this.getActiveLookups(ELookup.DocumentType);
        //this.getActiveLookups(ELookup.DocumentSourceType);
        this.get();
    }

    ngAfterViewInit(): void {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }

    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.DocumentType:
                        this.documentTypes = result.value;
                        break;
                    case ELookup.DocumentSourceType:
                        this.documentSourceTypes = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }
    public onSelectDocumentTypeChange(event: any) {
        let selectedText = this.documentTypes.filter(t => (t.id == event.value))[0].ncaaCode;
        if (selectedText)
            this.isHighSchool = selectedText.toLocaleLowerCase().indexOf('hs') >= 0;
    }

    openDialog() {
        let searchText = '';
        if(this.isHighSchool)
        {
            searchText = this.studentDocumentFormGroup.controls["highSchoolDescription"].value
        }
        else
        {
            searchText = this.studentDocumentFormGroup.controls["institutionDescription"].value
        }
        this.institutionSearchDialogRef = this.dialog.open(InstitutionSearchDialog, {
            width: '70%', height: '70%', data: {
                searchText: searchText, studentID: this.studentID, isHighSchool: this.isHighSchool, title: 'University Search'
            }
        });
        this.institutionSearchDialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                if (this.isHighSchool) {
                    this.studentDocumentFormGroup.get('highSchoolDescription').setValue(result["description"]);
                    this.studentDocumentFormGroup.get('highSchoolInstitutionId').setValue(result["id"]);
                    this.studentDocument.highSchoolDescription = result["description"];
                    this.studentDocument.highSchoolInstitutionId = result["id"];
                }
                else {
                    this.studentDocumentFormGroup.get('institutionDescription').setValue(result["description"]);
                    this.studentDocumentFormGroup.get('documentSourceTypeId').setValue(result["id"]);
                    this.studentDocument.institutionDescription = result["description"];
                    this.studentDocument.documentSourceTypeId = result["id"];
                }
                this.studentDocumentFormGroup.get('description').setValue(result["description"]);
                this.studentDocument.description = result["description"];
            }
        });
    }
    private get() {
        this._studentdocumentservice.get(this.studentID).subscribe((result: ApiResult<IStudentDocument[]>) => {
            if (result.validationErrors == null) {
                this.dataSource = new MatTableDataSource<IStudentDocument>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        });
    }
    private getDocuments(studentDocumentId: Guid) {
        this._studentdocumentservice.getDocumentsById(studentDocumentId).subscribe((result: ApiResult<IDocumentStore[]>) => {
            if (result.validationErrors == null) {
                this.documentDataSource = new MatTableDataSource<IDocumentStore>(result.value);
                this.documentDataSource.paginator = this.documentPaginator;
                this.documentDataSource.sort = this.documentSort;
            }
        });
    }
    add() {
        this.studentDocument = emptyStudentDocument();
        this.fillForm(this.studentDocument);
        this.isShown = true;
        this.isEdit = false;
        this.isHighSchool = false;
    }
    editDocument(id: Guid) {
        this._studentdocumentservice.getById(id).subscribe((result: ApiResult<IStudentDocument>) => {
            if (result.validationErrors == null && result.value != null) {
                this.studentDocument = result.value;
                this.fillForm(this.studentDocument);
                this.isShown = true;
                this.isEdit = true;
                this.isHighSchool = this.studentDocument.highSchoolInstitutionId > 0;
                this.getDocuments(id);
            }
        });
    }
    deleteDocument(id: Guid) {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: Messages.DeleteConfirm }
        });
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                this._studentdocumentservice.delete(id).subscribe((result: ApiResult<IStudentDocument>) => {
                    if (result.validationErrors == null) {
                        this.notify(Messages.DocumentDeleted);
                        this.get()
                        this.cancel();
                    }
                });
            }
        });
    }
    received(id: Guid) {
        this._studentdocumentservice.received(id).subscribe((result: ApiResult<number>) => {
            if (result.validationErrors == null) {
                this.notify(Messages.DocumentSaved);
                this.get();
            }
        });
    }
    cancel() {
        this.studentDocumentFormGroup.reset();
        this.isShown = false;
        this.isEdit = false;
        this.studentDocument = emptyStudentDocument();
    }
    onFileDropped(event: any) {
        var files = event.target.files;
        this.uploadFiles = [];
        for (const item of files) {
            item.progress = 0;
            this.uploadFiles.push(item);
        }
        const formData: FormData = new FormData();
        formData.append('fileField', this.uploadFiles[0], this.uploadFiles[0].name);
        formData.append('studentId', this.studentID.toString());
        formData.append('studentDocumentId', this.studentDocument.studentDocumentId.toString());
        formData.append('fileName', this.uploadFiles[0].name);
        formData.append('fileExtension', "");
        event.target.value = "";
        this._studentdocumentservice.fileUpload(formData).subscribe(
            result => {
                this.getDocuments(this.studentDocument.studentDocumentId);
                this.uploadFiles = [];
                this.isShown = true;
                this.isEdit = true;
            }
        );
    }
    download(documentStore:IDocumentStore) {        
        this._studentdocumentservice.downloadDocument(documentStore.documentStoreId,this.studentID).subscribe(data => {
            if (documentStore.fileExtension.toLocaleLowerCase() === ".pdf") {
                    this._exportService.downloadPdf(data, documentStore.fileName);
            }
            else{
                    this._exportService.downloadFile(data, documentStore.fileName);
            }
        });                
    }
    private fillForm(studentDocument: IStudentDocument) {
        this.studentDocumentFormGroup = this._formBuilder.group({
            studentDocumentId: [studentDocument.studentDocumentId],
            documentTypeId: [studentDocument.documentTypeId, Validators.required],
            documentSourceTypeId: [studentDocument.documentSourceTypeId],
            institutionDescription: [studentDocument.institutionDescription],
            highSchoolInstitutionId: [studentDocument.highSchoolInstitutionId],
            highSchoolDescription: [studentDocument.highSchoolDescription],
            description: [studentDocument.description],
            requestDate: [studentDocument.requestDate],
            receiveDate: [studentDocument.receiveDate],
            isOfficial: [studentDocument.isOfficial],
        });
    }
    onSubmit() {
        this.studentDocument = this.studentDocumentFormGroup.value as IStudentDocument;
        if (this.isHighSchool) {
            this.studentDocument.documentSourceTypeId = null;
        }
        else {
            this.studentDocument.highSchoolInstitutionId = null;
        }
        this.studentDocument.studentId = this.studentID;
        this.studentDocument.tenantId = Guid.parse(env.tenantId).toJSON().value;
        if (this.studentDocument.studentDocumentId !== null) {
            this._studentdocumentservice.put(this.studentDocument).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.DocumentSaved); 
                    this.get();                      
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            });
        }
        else {
            this.studentDocument.studentDocumentId = Guid.createEmpty().toJSON().value;
            this._studentdocumentservice.post(this.studentDocument).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {                   
                    this.notify(Messages.DocumentSaved);
                    this.get();   
                    this.cancel();
                }
                else {
                    this.studentDocument.studentDocumentId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }
    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['red-snackbar']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify(message: string) {
        let snackBarRef = this._snackBar.open(message, "Close", {
            duration: 2000,
        });       
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }
}
